/*
 * Want to add a service? go/generator-shared-service
 */
import lodash from './lodash';

export default angular.module('webDashboard.app.shared.services', [
])
.service('_', lodash);



// WEBPACK FOOTER //
// ./src/app/shared/services/index.js